import { RoutesBuilder } from './utils';

export const buildPlatformRoutes: RoutesBuilder = (instance) => []